/*
 * Calculadora de porção Amordida (fonte única).
 * Mesma conta do Amordida Sempre (sections/page-amordida-sempre.liquid):
 *   kcal/dia = 80 × peso^0,75 × atividade × condição × fatorExtra da linha
 *   g/dia    = kcal/dia ÷ kcal/kg da linha × 1000, arredondado para cima de 10 em 10
 * O kcal/kg é por linha. A linha Light não tem redução própria: o fator
 * de redução vem só da condição corporal (sobrepeso).
 *
 * Uso: window.AmordidaCalculadora.calcularGramasDia({ peso, atividade, condicao, linha })
 */
(function (root) {
  'use strict';

  var TAMANHO_EMBALAGEM_G = 300;

  var LINHAS = {
    adulto:       { nome: 'Best For Life Cães Adultos',          kcalPorKg: 1600, fatorExtra: 1.0 },
    filhote:      { nome: 'Best For Life Cães Filhotes',         kcalPorKg: 1800, fatorExtra: 2.0 },
    senior:       { nome: 'Best For Life Cães Sênior',           kcalPorKg: 1300, fatorExtra: 1.0 },
    pele:         { nome: 'Sensitive Cães Adultos e Sênior',     kcalPorKg: 1300, fatorExtra: 1.0 },
    gastro:       { nome: 'Low Fat Cães Adultos e Sênior',       kcalPorKg: 1250, fatorExtra: 1.0 },
    light:        { nome: 'Light Cães Adultos e Sênior',         kcalPorKg: 1200, fatorExtra: 1.0 },
    seletividade: { nome: 'Super Paladar Cães Adultos e Sênior', kcalPorKg: 1300, fatorExtra: 1.0 }
  };

  var FATOR_ATIVIDADE = { sedentario: 0.95, moderado: 1.0, ativo: 1.1 };
  var FATOR_CONDICAO = { magro: 1.1, ideal: 1.0, sobrepeso: 0.85 };

  // Retorna gramas por dia (arredondadas para cima, de 10 em 10), ou null se a entrada for inválida
  function calcularGramasDia(entrada) {
    var linha = LINHAS[entrada.linha];
    var peso = parseFloat(entrada.peso);
    var atividade = FATOR_ATIVIDADE[entrada.atividade || 'moderado'];
    var condicao = FATOR_CONDICAO[entrada.condicao || 'ideal'];
    if (!linha || !peso || peso <= 0 || !atividade || !condicao) return null;

    var kcalDia = 80 * Math.pow(peso, 0.75) * atividade * condicao * linha.fatorExtra;
    var gramasBruto = (kcalDia / linha.kcalPorKg) * 1000;
    return Math.ceil(gramasBruto / 10) * 10;
  }

  // Embalagens de 300 g necessárias para cobrir N dias
  function embalagensParaDias(gramasDia, dias) {
    return Math.ceil((gramasDia * dias) / TAMANHO_EMBALAGEM_G);
  }

  var api = {
    LINHAS: LINHAS,
    FATOR_ATIVIDADE: FATOR_ATIVIDADE,
    FATOR_CONDICAO: FATOR_CONDICAO,
    TAMANHO_EMBALAGEM_G: TAMANHO_EMBALAGEM_G,
    calcularGramasDia: calcularGramasDia,
    embalagensParaDias: embalagensParaDias
  };

  root.AmordidaCalculadora = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : this);
